import React from 'react'

import { Speed as SpeedIcon } from '@material-ui/icons'

import LockArrow from 'assets/Icons/LockArrow'
import Tooltip from 'components/Tooltip'
import TransferListCard from 'components/UsersGoal/components/TransferListCard'
import { IGoal, IUserWorking } from 'store/modules/goal/types'

import { Column, Header, List, SelectionBox, WeightCounter } from './styles'

export interface SellerTransferListProps {
  data: IGoal
  expectedWeight: number
  hasLockedWeights: boolean
  hasWeightError: boolean
  layout: 'bulk' | 'individual'
  unlockTooltipId: string
  usersAccWeight: number
  usersNotWorking: IUserWorking[]
  usersWorking: IUserWorking[]
  visibleNotWorkingCount?: number
  visibleWorkingCount?: number
  weightTooltipId: string
  onAdd: (user: IUserWorking) => void
  onRemove: (user: IUserWorking) => void
  onUnlockWeights: () => void
  onUpdateDsr: (user: IUserWorking, dsr: boolean) => void
  onUpdateWeight: (user: IUserWorking, type: 'auto' | 'fixed', weight: number) => void
}

const SellerTransferList = ({
  data,
  expectedWeight,
  hasLockedWeights,
  hasWeightError,
  layout,
  unlockTooltipId,
  usersAccWeight,
  usersNotWorking,
  usersWorking,
  visibleNotWorkingCount = usersNotWorking.length,
  visibleWorkingCount = usersWorking.length,
  weightTooltipId,
  onAdd,
  onRemove,
  onUnlockWeights,
  onUpdateDsr,
  onUpdateWeight
}: SellerTransferListProps) => (
  <SelectionBox layout={layout}>
    <Column layout={layout}>
      <Header layout={layout}>
        {layout === 'bulk' ? (
          <>
            <h2>Não participam</h2>
            <span>{usersNotWorking.length}</span>
          </>
        ) : (
          <div>
            <h1>Não participam</h1>
            <span>{usersNotWorking.length}</span>
          </div>
        )}
      </Header>
      <List layout={layout}>
        {usersNotWorking.slice(0, visibleNotWorkingCount).map((user, index) => (
          <TransferListCard
            key={layout === 'bulk' ? user.userId?._id : index}
            user={user}
            onClick={() => onAdd(user)}
          />
        ))}
      </List>
    </Column>

    <Column layout={layout}>
      <Header layout={layout}>
        <div>
          {layout === 'bulk' ? <h2>Participam da meta</h2> : <h1>Participam da meta</h1>}
          <span>{usersWorking.length}</span>
        </div>
        <WeightCounter error={hasWeightError} layout={layout}>
          <div data-tip data-for={weightTooltipId}>
            <Tooltip
              fixed
              place='top'
              id={weightTooltipId}
              content={<p>{hasWeightError ? `Ajuste os pesos para totalizar ${expectedWeight.toFixed(0)}%` : 'Total de pesos acumulado dos vendedores'}</p>}
            />
            <SpeedIcon fontSize='small' />
            <h3>{usersAccWeight.toFixed(0)}%</h3>
          </div>
          {hasLockedWeights && (
            <div data-tip data-for={unlockTooltipId}>
              <Tooltip
                fixed
                place='top'
                id={unlockTooltipId}
                content={<p>Desafixar peso dos vendedores para cálculo de Peso Automático</p>}
              />
              <button type={layout === 'bulk' ? 'button' : undefined} onClick={onUnlockWeights}>
                <LockArrow />
              </button>
            </div>
          )}
        </WeightCounter>
      </Header>
      <List layout={layout}>
        {usersWorking.slice(0, visibleWorkingCount).map((user, index) => (
          <TransferListCard
            usersWorking={usersWorking}
            working
            key={layout === 'bulk' ? user.userId?._id : index}
            user={user}
            inGoal
            data={data}
            updateUserDSR={onUpdateDsr}
            updateUserWeight={onUpdateWeight}
            onClick={() => onRemove(user)}
          />
        ))}
      </List>
    </Column>
  </SelectionBox>
)

export default React.memo(SellerTransferList)
